/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import styled from "styled-components";
import { MarginProps } from "styled-system";
import Box from "../Box";
import { DriveSlotItem } from "../../types/drive";
import { CTag } from "@carrefour/design-system-components-react";
import dayjs, { Dayjs } from "dayjs";

const CTagCustum = styled(CTag)<{
  width?: string;
  strip?: string;
}>`
  font-family: system-ui;
  height: 100%;
  border-radius: 4px;
  width: ${(props) => props.width};
  font-size: large;
  font-weight: 700;
  size: 28px;
  background: ${(props) => props.theme?.colors?.[`striped${props.strip}`]};
`;
const BoxCustom = styled(Box)``;
const getSlotStatusColor = (
  bookedCount: number,
  capacity: number,
  status: DriveSlotItem["status"]
) => {
  const occupancyRate = bookedCount / capacity;
  if (status === "OPEN") {
    if (occupancyRate === 1) {
      return "error";
    } else if (occupancyRate > 0.5 && occupancyRate < 1) {
      return "info";
    } else return "success";
  } else {
    // status === "closed"
    if (occupancyRate === 1) {
      return "error";
    } else if (occupancyRate > 0.5 && occupancyRate < 1) {
      return "info";
    } else return "success";
  }
};
const getSlotColor = (
  bookedCount: number,
  capacity: number,
  status: DriveSlotItem["status"]
) => {
  const occupancyRate = bookedCount / capacity;
  if (status === "CLOSE" || status === "FULL") {
    if (occupancyRate === 1) {
      return "Red";
    } else if (occupancyRate > 0.5 && occupancyRate < 1) {
      return "Blue";
    } else return "Green";
  }
};

type SlotProps = DriveSlotItem & {
  slotsCount: number;
  minStartDateTime: Dayjs;
} & MarginProps;

const Slot = ({ capacity, bookedCount, slotsCount, status, startDateTime, endDateTime, minStartDateTime }: SlotProps) => {
  const diffMinutes = dayjs(endDateTime).diff(startDateTime, "minute")
  const height = (diffMinutes / 30) * 40; 

  const startMinutes = dayjs(startDateTime).diff(minStartDateTime, "minute");
  const top = (startMinutes / 30) * 40;
  return (
    <BoxCustom marginTop={top} height={height} width={"100%"} lineHeight={"20px"} data-testid="slot-box" px={1} paddingTop={"2px"} paddingBottom={"2px"}>
      <CTagCustum
        status={getSlotStatusColor(bookedCount, capacity, status)}
        strip={getSlotColor(bookedCount, capacity, status)}
        hasBorder={false}
        size="l"
        width={"100%"}
        data-testid="slot-tag"
      >
        {bookedCount}/{capacity}
      </CTagCustum>
    </BoxCustom>
  );
};

export default Slot;
